export default __webpack_public_path__ + "static/media/refund.7efb3781.svg";